import { ClientNode } from '../../../../model/client-model/client-node';
import { Dict } from '../../../../model/dict';
import { DashboardNodeV3 } from '../../v3/dashboard-node-v3';
import { DashboardV3 } from '../../v3/dashboard-v3';
import { ClientBoardContainer } from '../model/client-board-container';
import { DashboardNodeV4 } from '../model/dashboard-node-v4/dashboard-node-v4';
import { DashboardV4 } from '../model/dashboard-v4';

export function getChildren(board: DashboardV4, parent: DashboardNodeV4 | DashboardV4): DashboardNodeV4[];
export function getChildren(board: DashboardV3, parent: DashboardNodeV3 | DashboardV3): DashboardNodeV3[];
export function getChildren(board: ClientBoardContainer, parent: ClientNode | ClientBoardContainer): ClientNode[];
export function getChildren<T extends ClientNode, U extends { childNodes: string[]; nodes: Dict<T> }>(
  board: U,
  parent: U | T
): T[] {
  if (!parent.childNodes) {
    return [];
  }
  return parent.childNodes
    .map((id) => {
      return board.nodes[id];
    })
    .filter((n) => !!n) as T[];
}
